export const RN_OPEN_CHATBOT = 'RN_OPEN_CHATBOT';
export const RN_OPEN_TICKETS = 'RN_OPEN_TICKETS';
export const RN_ANALYTICS_EVENT_INGESTION = 'RN_ANALYTICS_EVENT_INGESTION';
export const RN_FAQ_DEEPLINK = 'RN_FAQ_DEEPLINK';
